export const APIURL = "https://crm.resultfirst.com/backend/api/";
export const USERAPIURL = "https://pep.tangence.com/api/";

//export const APIURL = "http://localhost/clientcrm_backend/api/";
//export const USERAPIURL = "http://localhost/pep/api/";

